import { render, staticRenderFns } from "./RegisterStep1.vue?vue&type=template&id=648c2ce2&"
import script from "./RegisterStep1.vue?vue&type=script&lang=js&"
export * from "./RegisterStep1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports